// ============================================================================
// POLISH TRANSLATIONS - BIBLE FACTS
// ============================================================================
// Ciekawe fakty biblijne

export const bibleFacts = [
  {
    category: "statystyki",
    text: "Biblia zawiera łącznie 31 173 wersety",
    source: "Analiza tekstualna rękopisów"
  },
  {
    category: "języki",
    text: "Biblia została przetłumaczona na ponad 3000 różnych języków",
    source: "Zjednoczone Towarzystwa Biblijne"
  },
  {
    category: "redakcja",
    text: "Biblia była pisana przez około 1600 lat przez 40 różnych autorów",
    source: "Studia historyczne biblijne"
  },
  {
    category: "struktura",
    text: "Psalm 119 jest najdłuższym rozdziałem zawierającym 176 wersetów",
    source: "Struktura kanoniczna"
  },
  {
    category: "rekordy",
    text: "Najkrótszy werset w języku polskim to 'Jezus zapłakał' (Jana 11:35)",
    source: "Analiza tekstualna"
  },
  {
    category: "symbolizm",
    text: "Liczba 7 symbolizuje doskonałość i pojawia się 735 razy",
    source: "Studia numeryczne biblijne"
  },
  {
    category: "słownictwo",
    text: "Słowo 'miłość' w różnych formach pojawia się ponad 500 razy",
    source: "Konkordancja biblijna"
  }
];

export default bibleFacts;
